import { envConfig } from '../../../env';
import { Post } from '../../service/request/server';
import { deepCopy } from '@/utils/object';

export function insertProjectGroup(name, projectId, roleId) {
    return Post(envConfig.formalServer + "/cotton/insertProjectGroup", {name, projectId, roleId})
}

export function deleteProjectGroup(id) {
    return Post(envConfig.formalServer + "/cotton/deleteProjectGroup", {id})
}

export function updateProjectGroup(data) {
    return Post(envConfig.formalServer + "/cotton/updateProjectGroup", data)
}

/**
 * 这是一个分页查询，只会返回当前用户的所有项目组信息
 * @param id
 * @param name
 * @param projectId
 * @param roleId
 * @param pageNum
 * @returns {Promise<unknown>}
 */
export function selectProjectGroupList(id, name, projectId, roleId, pageNum, userId) {
    return new Promise((resolve, reject) => {
        Post(envConfig.formalServer + '/cotton/selectProjectGroupList', {
            id,
            name,
            projectId,
            pageNum,
            roleId,
            userId
        }).then(result => {
            if (result.code !== 200) {
                resolve(result);
            } else {
                if (result.data) {
                    let groupArr = deepCopy(result.data.result);
                    result.data.result = [];
                    groupArr.forEach((group, index) => {
                        if (group.name !== '超级管理员组') {
                            result.data.result.push(group);
                        }
                        if (index === groupArr.length - 1) {
                            resolve(result);
                        }
                    });
                } else {
                    resolve(result);
                }
            }
        });
    });
}